export type AssistantIntro = {
  seen: () => boolean;
  remember: () => void;
};

export const assistantIntroFor = (personId: string): AssistantIntro => {
  const key = `assistant-intro-seen:${personId}`;
  return {
    seen: () => {
      try {
        return localStorage.getItem(key) !== null;
      } catch {
        return true;
      }
    },
    remember: () => {
      try {
        localStorage.setItem(key, new Date().toISOString());
      } catch {
        return;
      }
    },
  };
};
